/**
 * Pure decision helper for ProjectDetailPage's confirmRules() flow.
 *
 * Extracted so the Step-1 → Step-2 transition logic (and the
 * promotion-guard "blocked" branch) can be unit-tested without
 * rendering the full page. Mirrors the exact branching that used to
 * live inline in confirmRules() — no behavior change.
 */
export function deriveConfirmRulesOutcome(data) {
  const results = (data && data.results) || [];
  const blocked = results.filter((x) => x.status === 'blocked');
  const enginePending = results.filter((x) => x.status === 'selected_engine_pending');
  const requiresScope = results.filter((x) => x.status === 'requires_scope');
  const savedCount = Number((data && data.confirmed_rules) || 0);
  const activeCount = Number((data && data.active_rules) ?? savedCount);

  return {
    blocked,
    enginePending,
    requiresScope,
    savedCount,
    activeCount,
    advanceToStep2: activeCount > 0,
    markConfirmed: activeCount > 0,
  };
}
